<div class="ui-g ui-fluid" style="position: relative">
  <div class="ui-g-12 ui-lg-12">
    <div class="card card-w-title ui-g">
      <h1>Edit Task Location</h1>

      <div class="ui-g-12">
        <div>
          <div class="ui-g-6 ui-sm-12">
            <form>
              <p-panel header="Collection Address Details">
                <div class="address-search-container-simplified">
                  <div class="address-search-container-query-fields">
                    <div class="address-search-input">
                      <div class="search-input" id="searchPickUpContainer">
                        <span class="search-input-icon">
                          <i class="las la-search"></i>
                        </span>
                        <input
                          type="text"
                          placeholder="Quick search address..."
                          id="searchPickUp"
                          name="searchPickUp"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="address-search-container-editor" *ngIf="addressSearchPickupLocation">
                    <div class="ui-grid ui-grid-responsive ui-fluid">
                      <div class="ui-g-12">
                        <div class="ui-g-3">
                          <label for="pickupBusinessName">Business Name</label>
                        </div>
                        <div class="ui-g-9">
                          <input
                            pInputText
                            id="pickupBusinessName"
                            [(ngModel)]="addressSearchPickupLocation.businessName"
                            (ngModelChange)="onPickupAddressManualEntry()"
                            [ngModelOptions]="{ standalone: true }"
                          />
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-g-3">
                          <label for="pickupLine1">Address Line 1*</label>
                        </div>
                        <div class="ui-g-9">
                          <input
                            pInputText
                            id="pickupLine1"
                            [(ngModel)]="addressSearchPickupLocation.addressLine1"
                            (ngModelChange)="onPickupAddressManualEntry()"
                            [ngModelOptions]="{ standalone: true }"
                          />
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-g-3">
                          <label for="pickupLine2">Address Line 2</label>
                        </div>
                        <div class="ui-g-9">
                          <input
                            pInputText
                            id="pickupLine2"
                            [(ngModel)]="addressSearchPickupLocation.addressLine2"
                            (ngModelChange)="onPickupAddressManualEntry()"
                            [ngModelOptions]="{ standalone: true }"
                          />
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-g-3">
                          <label for="pickupLine3">Address Line 3</label>
                        </div>
                        <div class="ui-g-9">
                          <input
                            pInputText
                            id="pickupLine3"
                            [(ngModel)]="addressSearchPickupLocation.addressLine3"
                            (ngModelChange)="onPickupAddressManualEntry()"
                            [ngModelOptions]="{ standalone: true }"
                          />
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-g-3">
                          <label for="pickupCity">Town*</label>
                        </div>
                        <div class="ui-g-9">
                          <input
                            pInputText
                            id="pickupCity"
                            [(ngModel)]="addressSearchPickupLocation.city"
                            (ngModelChange)="onPickupAddressManualEntry()"
                            [ngModelOptions]="{ standalone: true }"
                          />
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-g-3">
                          <label for="pickupPostalCode">Postcode*</label>
                        </div>
                        <div class="ui-g-9">
                          <input
                            pInputText
                            [postcodeFormat]
                            id="pickupPostalCode"
                            [(ngModel)]="addressSearchPickupLocation.postcode"
                            (ngModelChange)="onPickupAddressManualEntry()"
                            [ngModelOptions]="{ standalone: true }"
                          />
                          <small *ngIf="!isPickupPostcodeValidUKPostcodeFormat" class="text-danger">
                            Please make sure you have entered a valid postcode
                          </small>
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-g-3">
                          <label for="pickupWhat3Words">What3Words</label>
                        </div>
                        <div class="ui-g-9">
                          <input
                            pInputText
                            id="pickupWhat3Words"
                            [(ngModel)]="addressSearchPickupLocation.what3Words"
                            (paste)="removeSlashesOnPaste($event)"
                            (ngModelChange)="onPickupAddressManualEntry()"
                            [ngModelOptions]="{ standalone: true }"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="address-search-option-buttons">
                      <button
                        type="button"
                        pButton
                        label="Confirm Changes"
                        (click)="savePickupAddressManualEntry()"
                        *ngIf="displayAddressSearchPickupLocationManualSave"
                        style="width: 140px"
                      ></button>
                    </div>
                  </div>
                </div>
              </p-panel>

              <div style="margin-top: 20px">
                <p-panel header="Delivery Address Details">
                  <div class="address-search-container-simplified">
                    <div class="address-search-container-query-fields">
                      <div class="address-search-input">
                        <div class="search-input" id="searchDropoffContainer">
                          <span class="search-input-icon">
                            <i class="las la-search"></i>
                          </span>
                          <input
                            type="text"
                            placeholder="Quick search address..."
                            id="searchDropoff"
                            name="searchDropoff"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="address-search-container-editor"
                      *ngIf="addressSearchDropoffLocation"
                    >
                      <div class="ui-grid ui-grid-responsive ui-fluid">
                        <div class="ui-g-12">
                          <div class="ui-g-3">
                            <label for="dropoffBusinessName">Business Name</label>
                          </div>
                          <div class="ui-g-9">
                            <input
                              pInputText
                              id="dropoffBusinessName"
                              [(ngModel)]="addressSearchDropoffLocation.businessName"
                              (ngModelChange)="onDropoffAddressManualEntry()"
                              [ngModelOptions]="{ standalone: true }"
                            />
                          </div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-g-3">
                            <label for="dropoffLine1">Address Line 1*</label>
                          </div>
                          <div class="ui-g-9">
                            <input
                              pInputText
                              id="dropoffLine1"
                              [(ngModel)]="addressSearchDropoffLocation.addressLine1"
                              (ngModelChange)="onDropoffAddressManualEntry()"
                              [ngModelOptions]="{ standalone: true }"
                            />
                          </div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-g-3">
                            <label for="dropoffLine2">Address Line 2</label>
                          </div>
                          <div class="ui-g-9">
                            <input
                              pInputText
                              id="dropoffLine2"
                              [(ngModel)]="addressSearchDropoffLocation.addressLine2"
                              (ngModelChange)="onDropoffAddressManualEntry()"
                              [ngModelOptions]="{ standalone: true }"
                            />
                          </div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-g-3">
                            <label for="dropoffLine3">Address Line 3</label>
                          </div>
                          <div class="ui-g-9">
                            <input
                              pInputText
                              id="dropoffLine3"
                              [(ngModel)]="addressSearchDropoffLocation.addressLine3"
                              (ngModelChange)="onDropoffAddressManualEntry()"
                              [ngModelOptions]="{ standalone: true }"
                            />
                          </div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-g-3">
                            <label for="dropoffCity">Town*</label>
                          </div>
                          <div class="ui-g-9">
                            <input
                              pInputText
                              id="dropoffCity"
                              [(ngModel)]="addressSearchDropoffLocation.city"
                              (ngModelChange)="onDropoffAddressManualEntry()"
                              [ngModelOptions]="{ standalone: true }"
                            />
                          </div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-g-3">
                            <label for="dropoffPostalCode">Postcode*</label>
                          </div>
                          <div class="ui-g-9">
                            <input
                              pInputText
                              [postcodeFormat]
                              id="dropoffPostalCode"
                              [(ngModel)]="addressSearchDropoffLocation.postcode"
                              (ngModelChange)="onDropoffAddressManualEntry()"
                              [ngModelOptions]="{ standalone: true }"
                            />
                            <small
                              *ngIf="!isDropoffPostcodeValidUKPostcodeFormat"
                              class="text-danger"
                            >
                              Please make sure you have entered a valid postcode
                            </small>
                          </div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-g-3">
                            <label for="dropoffWhat3Words">What3Words</label>
                          </div>
                          <div class="ui-g-9">
                            <input
                              pInputText
                              id="dropoffWhat3Words"
                              [(ngModel)]="addressSearchDropoffLocation.what3Words"
                              (paste)="removeSlashesOnPaste($event)"
                              (ngModelChange)="onDropoffAddressManualEntry()"
                              [ngModelOptions]="{ standalone: true }"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="address-search-option-buttons">
                        <button
                          type="button"
                          pButton
                          label="Confirm Changes"
                          (click)="saveDropoffAddressManualEntry()"
                          *ngIf="displayAddressSearchDropoffLocationManualSave"
                          style="width: 140px"
                        ></button>
                      </div>
                    </div>
                  </div>
                </p-panel>
              </div>

              <div style="margin-top: 20px">
                <p-panel *ngIf="context && !hasCustomerBookingRole" [header]="customerPriceHeader">
                  <div *ngIf="isPriceLoading" class="text-lg">
                    <i class="fa fa-spinner fa-spin"></i>
                  </div>
                  <div *ngIf="!isPriceLoading">
                    <div class="grid">
                      <div class="col">Original:</div>
                      <div class="col" *ngIf="hasCustomerPriceRole; else noCustomerPriceRole">
                        £{{ context?.currentCustomerPriceMax }}
                      </div>
                      <ng-template #noCustomerPriceRole>
                        <div class="col" *ngIf="context.isFixedPrice">
                          £{{ context?.currentCustomerPrice }}
                        </div>
                        <div class="col" *ngIf="!context.isFixedPrice">
                          £{{ context?.currentCustomerPriceMin }} - £{{
                            context?.currentCustomerPriceMax
                          }}
                        </div>
                      </ng-template>
                    </div>
                    <div *ngIf="customerPriceResult?.customerPrice" class="grid font-bold">
                      <div class="col">New :</div>
                      <div class="col" *ngIf="hasCustomerPriceRole; else noCustomerPriceRole">
                        £{{ customerPriceResult?.customerPriceMax }}
                      </div>
                      <ng-template #noCustomerPriceRole>
                        <div class="col" *ngIf="context.isFixedPrice">
                          £{{ customerPriceResult?.customerPrice }}
                        </div>
                        <div class="col" *ngIf="!context.isFixedPrice">
                          £{{ customerPriceResult?.customerPriceMin }} - £{{
                            customerPriceResult?.customerPriceMax
                          }}
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </p-panel>
              </div>
              <div *ngIf="context" style="margin-top: 20px">
                <p-panel header="Supplier Price Change" *ngIf="context.isVme">
                  <div *ngIf="taskGrabbed" class="text-warning">
                    Task is already allocated. Supplier Price will need to be manually updated
                  </div>
                  <div *ngIf="isPriceLoading && !taskGrabbed" class="text-lg">
                    <i class="fa fa-spinner fa-spin"></i>
                  </div>
                  <div *ngIf="!isPriceLoading && !taskGrabbed">
                    <div class="grid">
                      <div class="col">Original BIN Price:</div>
                      <div class="col">£{{ context.currentBinPrice }}</div>
                    </div>
                    <div *ngIf="supplierPriceResult?.grabItNowPrice" class="grid font-bold">
                      <div class="col">New BIN Price:</div>
                      <div class="col">£{{ supplierPriceResult?.grabItNowPrice }}</div>
                    </div>
                  </div>
                </p-panel>
              </div>
              <div *ngIf="context" style="margin-top: 20px">
                <p-panel header="Customer Dropoff Window Change" *ngIf="hasDropoffWindowChanged">
                  <div *ngIf="isPriceLoading" class="text-lg">
                    <i class="fa fa-spinner fa-spin"></i>
                  </div>
                  <div *ngIf="!isPriceLoading">
                    <div class="grid">
                      <div class="col">Original Pickup Window:</div>
                      <div class="col">
                        {{ context.currentEarliestPickupDate | datex : ' DD/MM/YY HH:mm' }} to
                        {{ context.currentLatestPickupDate | datex : 'DD/MM/YY HH:mm' }}
                      </div>
                    </div>
                    <div class="grid">
                      <div class="col">Original Drive Time:</div>
                      <div class="col">
                        {{ context.currentRouteTimeMinutes | minutesToHoursMinutes }}
                      </div>
                    </div>
                    <div class="grid">
                      <div class="col">Original Dropoff Window:</div>
                      <div class="col">
                        {{ context.currentEarliestDropoffDate | datex : ' DD/MM/YY HH:mm' }} to
                        {{ context.currentLatestDropoffDate | datex : 'DD/MM/YY HH:mm' }}
                      </div>
                    </div>
                    <div
                      *ngIf="
                        customerPriceResult?.earliestDropoffDate &&
                        customerPriceResult?.latestDropoffDate
                      "
                      class="font-bold"
                    >
                      <div class="grid">
                        <div class="col">New Dropoff Window:</div>
                        <div class="col">
                          {{ customerPriceResult.earliestDropoffDate | datex : ' DD/MM/YY HH:mm' }}
                          to
                          {{ customerPriceResult.latestDropoffDate | datex : 'DD/MM/YY HH:mm' }}
                        </div>
                      </div>
                      <div class="grid">
                        <div class="col">New Drive Time:</div>
                        <div class="col">
                          {{ customerPriceResult.routeTimeMinutes | minutesToHoursMinutes }}
                        </div>
                      </div>

                      <label class="flex align-items-center align-center mt-2">
                        <p-checkbox
                          class="ml-1"
                          name="updateDropoffWindow"
                          [(ngModel)]="updateDropoffWindow"
                          binary="true"
                        ></p-checkbox>
                        Use new dropoff window on save
                      </label>
                    </div>
                  </div>
                </p-panel>
              </div>
            </form>
          </div>

          <div id="ajustementMap" class="ui-g-6 ui-sm-12">
            <div style="float: right; width: 100%">
              <map-control
                [(origin)]="originMarkerPoint"
                [(destination)]="destinationMarkerPoint"
                [customStyle]="{ height: '680px' }"
              >
              </map-control>
            </div>
            <div class="ui-g-12">
              <div class="my-2">
                <app-warning-container
                  warningTitle="Warning - Dropoff Window Changed"
                  *ngIf="hasDropoffWindowChanged && updateDropoffWindow"
                >
                  <span
                    >Due to the change in location, the drop-off window will be updated.
                    <span *ngIf="isVmeUser">Please ensure the customer is informed.</span>
                  </span>
                </app-warning-container>
              </div>
              <div class="my-2">
                <app-warning-container
                  warningTitle="Warning - Price Recalculation Skipped"
                  *ngIf="isCustomerRecalculationDisabled"
                >
                  <span
                    >The customer this task belongs to is configured to skip price recalculation on
                    location change.</span
                  >
                </app-warning-container>
              </div>
            </div>
            <div class="ui-g-12">
              <button
                type="button"
                (click)="cancel()"
                pButton
                icon="fa ui-icon-close"
                label="Cancel"
                class="ui-button btn-to-right"
                [disabled]="isPriceLoading"
              ></button>
              <button
                type="button"
                pButton
                icon="fa ui-icon-check"
                label="Save"
                (click)="saveClicked()"
                class="ui-button green-btn btn-to-right"
                [disabled]="isPriceLoading || isSaving"
              ></button>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog></p-confirmDialog>
